// Vditor编辑器配置文件

export const getVditorConfig = (options = {}) => {
  const defaultConfig = {
    height: "100%",
    placeholder: "请输入提示词内容，支持Markdown语法...",
    toolbar: [
      "headings", "bold", "italic", "strike", "link", "|",
      "list", "ordered-list", "check", "|",
      "quote", "code", "inline-code", "|",
      "table", "|",
      "undo", "redo", "|",
      "edit-mode", "preview"
    ],
    preview: {
      delay: 500,
      show: false,
      hljs: {
        enable: true,
        style: "github"
      }
    },
    cache: {
      enable: false
    },
    counter: {
      enable: true,
      type: "markdown"
    },
    theme: "classic",
    mode: "ir",
    upload: {
      enable: false
    },
    emoji: false,
    toc: false,
    typewriterMode: false,
    render: {
      enable: true
    }
  };

  return { ...defaultConfig, ...options };
};

export const preloadVditor = () => {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(() => {
      import("vditor").catch(() => { });
    });
  } else {
    setTimeout(() => {
      import("vditor").catch(() => { });
    }, 1000);
  }
};

export const getVditorInstanceConfig = (options = {}) => {
  const baseConfig = getVditorConfig(options);

  return {
    ...baseConfig,
    after: () => {
      if (options.after && typeof options.after === "function") {
        options.after();
      }
    },
    input: (value) => {
      if (options.input && typeof options.input === "function") {
        options.input(value);
      }
    }
  };
};
